import React, { useContext } from 'react'
import { Button } from 'syngenta-react-components'
import { GlobalContext } from '../../services/context'

const WelcomeView = props => {
  const { dispatch } = useContext(GlobalContext)

  const welcomeFunc = e => {
    e.preventDefault()
    dispatch({ type: 'LOGIN_USER' })
    props.history.push('/contracts')
  }

  return (
    <div>
      <h1>Welcome!</h1>
      <a href='/' onClick={welcomeFunc}>
        <Button type='success'text='Enter'>Enter</Button>
      </a>
    </div>
  )
}

export default WelcomeView